// extracted by mini-css-extract-plugin
module.exports = {"viewMoreWrapper":"ViewMore_viewMoreWrapper__5QAsS","title":"ViewMore_title__o704U","list":"ViewMore_list__w_B_X"};